import { ThunkAction } from "redux-thunk";
import { RootState } from "./reducer";
import { Action } from "redux";

import { initialFormData } from "./form/actions";
import CertificateAppealService from "src/services/CertificateAppeal​/CertificateAppealService";

type ThunkResult<R> = ThunkAction<R, RootState, {}, Action>;

export function getId(ID: string): ThunkResult<Promise<any>> {
  return async (dispatch) => {
    const certificateAppealService = new CertificateAppealService();
    try {
      const result = await certificateAppealService.GetId(ID);
      dispatch(initialFormData(result));
      return result;
    } catch (error) {
      const typedError = error as {
        response?: { status?: number; data?: any };
      };
      const status = typedError.response?.status || 500;
      const message =
        typedError.response?.data?.message || "Bilinmeyen bir hata oluştu";

      return Promise.reject({ status, message });
    }
  };
}
